import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Grid,
  FormControl,
  InputLabel,
  InputAdornment,
  OutlinedInput,
  Tooltip,
  Dialog,
  DialogTitle,
  Button,
  Snackbar,
  Alert,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import { appLogger, Http } from "../../utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { IconWithToolTip } from "../common";
import DeleteDialog from "../../utils/common/DeleteDialog";
import { ROLE_USER_SUPERADMIN, UserInfo, AuthDetails } from "../../model";
import {
  SORT_KEY_EMAIL,
  SORT_KEY_NAME,
  SORT_KEY_MODIFIED_ON,
  SORT_KEY_CREATED_BY,
} from "./constants";
// import UserForm from "./userForm";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import ConfirmDeleteModal from "./ConfirmDeleteModal";

import moment from "moment";
import { roleConfig } from "../../utils/config/role-config";

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}

function TablePaginationActions(props: TablePaginationActionsProps) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </Box>
  );
}

const ManageOrganizations = (props: any) => {
  const navigate = useNavigate();

  const {
    userInfo,
    setIsAuthenticated,
    setUserInfo,
    setProVersion,
    setcontextProVersion,
    orgId,
    setOrgId,
  } = useContext(UserContext) as UserLoginInfo;

  const [orderBy, setOrderBy] = useState(SORT_KEY_MODIFIED_ON);

  const [order, setOrder] = useState<"asc" | "desc">("desc");

  const [itemLimit, setItemLimit] = useState({
    lowerLimit: 0,
    upperLimit: 24,
  });

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [search, setSearch] = React.useState("");
  const [searchKeyword, setSearchKeyword] = React.useState("");
  const [isLoading, setIsloading] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
  const [openResetPwDialog, setOpenResetPwDialog] = useState(false);
  const [focusEmailId, setFocusEmailId] = useState("");
  const [alertOpenResetPw, setAlertOpenResetPw] = React.useState(false);
  const [errorAlertOpenResetPw, setErrorAlertOpenResetPw] =
    React.useState(false);

  const [org, setOrg] = useState<string | undefined>("");
  const [orgResponse, setOrgResponse] = useState<any>([]);
  const [orgByID, setOrgByID] = useState<any | undefined>(null);
  const [searchOrgs, setSearchOrgs] = React.useState([] as any);

  const [confirmDeleteModal, setConfirmDeleteModal] = useState<boolean>(false);

  const [selectedOrg, setSelectedOrg] = useState(null);

  const handleOpenConfirmDeleteModal = (org: any) => {
    setSelectedOrg(org);
    setConfirmDeleteModal(true);
  };

  const handleCloseConfirmDeleteModal = () => {
    setSelectedOrg(null);
    setConfirmDeleteModal(false);
  };

  const handleRedirectEditPage = (orgId: string) => {
    navigate(`/edit-organization/${orgId}`);
  };

  const handleFetchEnabledFeatures = async (id: string) => {
    try {
      const res: any = await Http.get({
        url: `/api/v2/enabledFeatures/${id}`,
      });
      if (
        res?.enabledFeatures &&
        Object.keys(res?.enabledFeatures).length > 0
      ) {
        const { enabledFeatures } = res;
        localStorage.setItem(
          "userenabledFeatures",
          JSON.stringify(enabledFeatures)
        );
      }
    } catch (err) {
      appLogger.error({
        errObj: {
          method: "handleFetchEnabledFeatures",
          component: "header",
          fileName: "basicDetails.tsx",
          err: err,
        },
      });
    }
  };

  const handleRole = (userDetails: any) => {
    for (const key in roleConfig) {
      if (userDetails.userRole == roleConfig[key]) {
        return key;
      }
    }
  };

  const handleUserOrgUpd = (orgId: string) => {
    if (userInfo && userInfo.userDetails && userInfo.userDetails.id) {
      Http.put({
        url: `/api/v2/users/`,
        body: {
          id: userInfo.userDetails.id,
          orgId: orgId,
        },
        state: userInfo,
      })
        .then((response) => {
          appLogger.info({
            infoObj: {
              method: "handleUserOrgUpd",
              component: "header",
              fileName: "index.tsx",
              userResponse: response,
            },
          });
          Http.get({
            url: `/api/v2/users/login`,
            // state: userStateVariable,
          })
            .then((response: any) => {
              if (response) {
                appLogger.info({
                  infoObj: {
                    method: "handleUserOrgUpd",
                    component: "header",
                    fileName: "index.tsx",
                    response: response,
                  },
                });
                response.userDetails.orgId = orgId;
                setcontextProVersion([]);
                setProVersion({
                  product: "",
                  version: "",
                });
                if (response.userDetails.userRole.length > 0) {
                  response.userDetails.userRole =
                    handleRole(response.userDetails) || "";
                }
                const obj: AuthDetails = {
                  isAuthenticated: true,
                  idToken: userInfo.idToken,
                  accessToken: userInfo.accessToken,
                  userDetails: response.userDetails,
                  isSsoUser: false,
                };
                setUserInfo(obj);
                if (
                  response &&
                  response.userDetails &&
                  response.userDetails &&
                  response.userDetails.orgId &&
                  response.userDetails.orgId != ""
                ) {
                  localStorage.setItem("userOrgId", response.userDetails.orgId);
                  handleFetchEnabledFeatures(response.userDetails.orgId);
                  navigate("/");
                }
              }
            })
            .catch((error: any) => {
              appLogger.error({
                errObj: {
                  method: "handleUserOrgUpd",
                  component: "header",
                  fileName: "index.tsx",
                  err: error,
                },
              });
            });
        })
        .catch((err) => {
          appLogger.error({
            errObj: {
              method: "handleUserOrgUpd",
              component: "header",
              fileName: "index.tsx",
              err: err,
            },
          });
        });
    }
  };

  const selectOrg = (id: any) => {
    setOrgId(id);
    handleUserOrgUpd(id);
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    if (event.target.value === "-1") {
      setItemLimit({
        lowerLimit: 0,
        upperLimit: orgResponse.length - 1,
      });
    } else {
      setItemLimit({
        lowerLimit: 0,
        upperLimit: parseInt(event.target.value, 10) - 1,
      });
    }
  };

  const handleRequestSort = (property: string) => {
    if (orderBy === property) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setOrder("asc");
      setOrderBy(property);
    }
  };

  const handleFetchOrganizations = () => {
    if (
      userInfo &&
      userInfo.userDetails &&
      userInfo.userDetails.userRole === ROLE_USER_SUPERADMIN
    ) {
      Http.get({
        url: `/api/v2/organizations/all`,
        state: userInfo,
      })
        .then((response: any) => {
          //sort organization by name
          response.organizationList.sort((a: any, b: any) => {
            if (a.name.toUpperCase() < b.name.toUpperCase()) {
              return -1;
            }
            if (a.name.toUpperCase() > b.name.toUpperCase()) {
              return 1;
            }
            return 0;
          });

          const sortedUsers = sortFunction(response.organizationList);
          setSearchOrgs(sortedUsers);

          // setOrgResponse(response.organizationList);
          if (userInfo && userInfo.userDetails && userInfo.userDetails.orgId) {
            const isOrgPresent = response.organizationList.find(
              (o: { orgId: string }) => {
                return (
                  userInfo &&
                  userInfo.userDetails &&
                  userInfo.userDetails.orgId === o.orgId
                );
              }
            );
            appLogger.info(
              {
                infoObj: {
                  method: "useEffect",
                  component: "header",
                  fileName: "index.tsx",
                  isOrgPresent: isOrgPresent,
                },
              },
              "Organization present for the user"
            );
            if (isOrgPresent && Object.keys(isOrgPresent).length > 0) {
              setOrgId(userInfo.userDetails.orgId);
            } else if (response.organizationList.length > 0) {
              setOrgId(response.organizationList[0].orgId);
              handleUserOrgUpd(response.organizationList[0].orgId);
            }
          }
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "header",
              fileName: "index.tsx",
              err: error,
            },
          });
        });
    } else {
      Http.get({
        url: `/api/v2/organizations/${localStorage.getItem("userOrgId")}`,
        state: userInfo,
      })
        .then((response: any) => {
          setOrgByID(response.organizationDetails);
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "header",
              fileName: "index.tsx",
              err: error,
            },
          });
        });
    }
  };

  useEffect(() => {
    handleFetchOrganizations();
  }, []);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleErrorAlertClose = () => {
    setErrorAlertOpen(false);
  };

  function compareFirstName(a: any, b: any) {
    return a.name.localeCompare(b.name);
  }

  function compareFirstNameDesc(a: any, b: any) {
    return b.name.localeCompare(a.name);
  }

  function compareCreatedOn(a: any, b: any) {
    return (
      new Date(a?.lastModifiedOn).getTime() -
      new Date(b?.lastModifiedOn).getTime()
    );
  }

  function compareCreatedOnDesc(a: any, b: any) {
    return (
      new Date(b?.lastModifiedOn).getTime() -
      new Date(a?.lastModifiedOn).getTime()
    );
  }

  function compareCreatedBy(a: UserInfo, b: UserInfo) {
    if (!b.createdBy && !a.createdBy) {
      return 0;
    }
    if (!b.createdBy) {
      return 1;
    }
    if (!a.createdBy) {
      return -1;
    }
    return a.createdBy.localeCompare(b.createdBy);
  }

  function compareCreatedByDesc(a: UserInfo, b: UserInfo) {
    if (!b.createdBy && !a.createdBy) {
      return 0;
    }
    if (!b.createdBy) {
      return -1;
    }
    if (!a.createdBy) {
      return 1;
    }
    return b.createdBy.localeCompare(a.createdBy);
  }

  function compareModifiedOn(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedOn && !a.lastModifiedOn) {
      return 0;
    }
    if (!b.lastModifiedOn) {
      return 1;
    }
    if (!a.lastModifiedOn) {
      return -1;
    }
    return b.lastModifiedOn > a.lastModifiedOn ? -1 : 1;
  }

  function compareModifiedOnDesc(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedOn && !a.lastModifiedOn) {
      return 0;
    }
    if (!b.lastModifiedOn) {
      return -1;
    }
    if (!a.lastModifiedOn) {
      return 1;
    }
    return b.lastModifiedOn > a.lastModifiedOn ? 1 : -1;
  }

  const sortFunction = (list: any) => {
    if (list.length > 0) {
      const tempSortedUsers = [...list];
      let sortedList: any = [];
      if (order === "asc") {
        if (orderBy === SORT_KEY_EMAIL) {
          sortedList = tempSortedUsers.sort(compareCreatedOn);
        } else if (orderBy === SORT_KEY_NAME) {
          sortedList = tempSortedUsers.sort(compareFirstName);
        } else if (orderBy === SORT_KEY_MODIFIED_ON) {
          sortedList = tempSortedUsers.sort(compareModifiedOn);
        } else if (orderBy === SORT_KEY_CREATED_BY) {
          sortedList = tempSortedUsers.sort(compareCreatedBy);
        }
      }
      if (order === "desc") {
        if (orderBy === SORT_KEY_EMAIL) {
          sortedList = tempSortedUsers.sort(compareCreatedOnDesc);
        } else if (orderBy === SORT_KEY_NAME) {
          sortedList = tempSortedUsers.sort(compareFirstNameDesc);
        } else if (orderBy === SORT_KEY_MODIFIED_ON) {
          sortedList = tempSortedUsers.sort(compareModifiedOnDesc);
        } else if (orderBy === SORT_KEY_CREATED_BY) {
          sortedList = tempSortedUsers.sort(compareCreatedByDesc);
        }
      }

      setOrgResponse(sortedList);
      return sortedList;
    }
  };

  useEffect(() => {
    sortFunction(orgResponse);
  }, [order, orderBy]);

  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      setSearchKeyword(search);
      e.preventDefault();
    }
  };

  const handleSearchTyping = (e: any) => {
    setSearch(e.target.value);
    if (e.target.value !== "") {
      const temp = searchOrgs;
      const filteredRows = temp.filter((row: any) => {
        return row.name.toLowerCase().includes(e.target.value.toLowerCase());
      });
      setOrgResponse(filteredRows);
    } else {
      setOrgResponse(searchOrgs);
    }
  };

  const searchClear = () => {
    setSearch("");
    setOrgResponse(searchOrgs);
  };

  const handleCloseResetPwDialog = () => {
    setOpenResetPwDialog(false);
  };

  const resetPassword = () => {
    setIsloading(true);
    const body = {
      emailId: focusEmailId,
    };
    Http.post({
      url: `/api/v2/users/reset-password`,
      state: userInfo,
      body,
    })
      .then((response: any) => {
        setAlertOpenResetPw(true);
        setOpenResetPwDialog(false);
        setIsloading(false);
        setFocusEmailId("");
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "resetPassword",
            component: "users",
            fileName: "manage.tsx",
            err: error,
          },
        });
        setIsloading(false);
        setErrorAlertOpenResetPw(true);
      });
  };

  const handleAlertCloseResetPw = () => {
    setAlertOpenResetPw(false);
  };

  const handleErrorAlertCloseResetPw = () => {
    setErrorAlertOpenResetPw(false);
  };

  return (
    <Box>
      <Grid className="manage-search" container spacing={2}>
        <Grid item xs={12} md={4} lg={2} sx={{ mb: 1 }}>
          <FormControl className="custom-select" fullWidth>
            <InputLabel>Search</InputLabel>
            <OutlinedInput
              type="text"
              value={search}
              onChange={handleSearchTyping}
              onKeyPress={handleKeyPress}
              id="search-input"
              endAdornment={
                <>
                  {search && (
                    <InputAdornment position="end" onClick={searchClear}>
                      <IconButton
                        aria-label="search icon"
                        edge="end"
                        className="search-fb-icon"
                      >
                        <CloseIcon className="cursor-pointer" />
                      </IconButton>
                    </InputAdornment>
                  )}
                  <InputAdornment position="end">
                    <IconButton aria-label="search icon" edge="end">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                </>
              }
              label="Search"
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box className="table-wrap">
        <Table className={isLoading ? "table loader" : "table"}>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_NAME}
                  direction={orderBy === SORT_KEY_NAME ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_NAME);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Name</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_NAME
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_EMAIL}
                  direction={orderBy === SORT_KEY_EMAIL ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_EMAIL);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Created On</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_EMAIL
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_MODIFIED_ON}
                  direction={orderBy === SORT_KEY_MODIFIED_ON ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_MODIFIED_ON);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Modified On</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_MODIFIED_ON
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>

              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_CREATED_BY}
                  direction={orderBy === SORT_KEY_CREATED_BY ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_CREATED_BY);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Create by</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_CREATED_BY
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>

              <TableCell>
                <Typography>Status</Typography>
              </TableCell>
              <TableCell>
                <Typography>Actions</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? orgResponse.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : orgResponse
            ).map((org: any, index: number) => {
              if (index < itemLimit.lowerLimit) {
                return;
              }
              if (index > itemLimit.upperLimit) {
                return;
              }

              return (
                <TableRow key={index}>
                  <TableCell>
                    <Tooltip
                      placement="top"
                      title="Click to switch to this organization"
                    >
                      <Typography
                        style={{ color: "#0157FF", cursor: "pointer" }}
                        onClick={() => selectOrg(org.orgId)}
                      >
                        {org.name}
                      </Typography>
                    </Tooltip>
                    <Typography></Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {moment(org?.createdOn).format("MM/DD/YYYY")}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {moment(org?.lastModifiedOn).format("MM/DD/YYYY")}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography>{org?.createdBy}</Typography>
                  </TableCell>

                  <TableCell>
                    <Typography>{org?.status}</Typography>
                  </TableCell>
                  <TableCell>
                    {org?.status !== "Deleted" && (
                      <List className="table-options" sx={{ display: "flex" }}>
                        <ListItem
                          onClick={() => handleRedirectEditPage(org.orgId)}
                        >
                          <ListItemText
                            primary={
                              <IconWithToolTip
                                message="Edit Organization"
                                iconName="icon-edit"
                              />
                            }
                          />
                        </ListItem>

                        <ListItem
                          onClick={() =>
                            org?.parent
                              ? handleOpenConfirmDeleteModal(org)
                              : null
                          }
                        >
                          {org?.parent && (
                            <ListItemText
                              primary={
                                <IconWithToolTip
                                  message="Delete Organization"
                                  iconName="icon-delete"
                                />
                              }
                            />
                          )}
                        </ListItem>

                        <ListItem
                          sx={{
                            marginLeft: org?.parent ? "0px" : "10px",
                          }}
                        >
                          <Button
                            variant="text"
                            sx={{
                              fontSize: "10px",
                              padding: 0,
                              margin: 0,
                            }}
                            onClick={() => selectOrg(org.orgId)}
                          >
                            Switch to org
                          </Button>
                        </ListItem>
                      </List>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          <TableFooter>
            <TableRow></TableRow>
          </TableFooter>
        </Table>
        <TablePagination
          component="div"
          rowsPerPageOptions={[25, 50, 100]}
          count={orgResponse.length}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </Box>

      <Dialog
        className="form-container text-center"
        onClose={handleCloseResetPwDialog}
        open={openResetPwDialog}
      >
        <Box
          className={isLoading ? "form-wrap loader" : "form-wrap"}
          style={{ paddingLeft: "24px", paddingRight: "24px" }}
        >
          <DialogTitle>Reset Password</DialogTitle>
          <Typography className="info">
            Do you really want to reset password for {focusEmailId}?
          </Typography>
          <Box style={{ paddingBottom: "16px", paddingTop: "16px" }}>
            <Button variant="contained" onClick={resetPassword}>
              reset
            </Button>
            <Button
              variant="text"
              onClick={handleCloseResetPwDialog}
              style={{ marginLeft: "10px" }}
            >
              cancel
            </Button>
          </Box>
        </Box>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertOpen}
        autoHideDuration={2000}
        onClose={handleAlertClose}
      >
        <Alert onClose={handleAlertClose} severity="success">
          user deleted successfully !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorAlertOpen}
        autoHideDuration={2000}
        onClose={handleErrorAlertClose}
      >
        <Alert onClose={handleErrorAlertClose} severity="error">
          Error in user delete !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertOpenResetPw}
        autoHideDuration={2000}
        onClose={handleAlertCloseResetPw}
      >
        <Alert onClose={handleAlertCloseResetPw} severity="success">
          Password reset successfully !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorAlertOpenResetPw}
        autoHideDuration={2000}
        onClose={handleErrorAlertCloseResetPw}
      >
        <Alert onClose={handleErrorAlertCloseResetPw} severity="error">
          Error in password reset !!!
        </Alert>
      </Snackbar>

      {confirmDeleteModal && (
        <ConfirmDeleteModal
          handleFetchOrganizations={handleFetchOrganizations}
          selectedOrg={selectedOrg}
          open={confirmDeleteModal}
          onClose={handleCloseConfirmDeleteModal}
        />
      )}
    </Box>
  );
};

export default ManageOrganizations;
